/**
 * Countries of residence we do not onboard (must match `value` in COUNTRIES dropdown).
 * Add country names here to block selection during basic-details onboarding.
 */
export const RESTRICTED_COUNTRY_OF_RESIDENCE_VALUES = ['United States'] as const

export type RestrictedCountryOfResidence = (typeof RESTRICTED_COUNTRY_OF_RESIDENCE_VALUES)[number]

const restrictedSet = new Set<string>(RESTRICTED_COUNTRY_OF_RESIDENCE_VALUES)

export function isRestrictedCountryOfResidence(country: string): boolean {
  return restrictedSet.has(country.trim())
}

export function formatRestrictedCountryList(): string {
  const names = [...RESTRICTED_COUNTRY_OF_RESIDENCE_VALUES]
  if (names.length === 0) return ''
  if (names.length === 1) return names[0]
  if (names.length === 2) return `${names[0]} or ${names[1]}`
  return `${names.slice(0, -1).join(', ')}, or ${names[names.length - 1]}`
}

export const RESTRICTED_COUNTRY_OF_RESIDENCE_MESSAGE =
  'We are currently unable to onboard clients whose country of residence is'

/** User-facing warning: names only the selected country so copy stays short as the list grows. */
export function getRestrictedCountryOfResidenceWarning(country: string): string | null {
  if (!isRestrictedCountryOfResidence(country)) return null
  const selected = country.trim()
  return `${RESTRICTED_COUNTRY_OF_RESIDENCE_MESSAGE} ${selected}. Please select a different country or contact support@credibila.com for assistance.`
}

export function getRestrictedCountryOfResidenceValidationError(country: string): string | null {
  return getRestrictedCountryOfResidenceWarning(country)
}
